import { render, staticRenderFns } from "./autoRefundModule.vue?vue&type=template&id=61b25803&scoped=true"
import script from "./autoRefundModule.vue?vue&type=script&lang=js"
export * from "./autoRefundModule.vue?vue&type=script&lang=js"
import style0 from "./autoRefundModule.vue?vue&type=style&index=0&id=61b25803&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b25803",
  null
  
)

export default component.exports